export const buildRemoteUrl = (baseUrl: string, label = "Bootstrap") => {
  try {
    const remoteUrl = new URL(baseUrl);
    remoteUrl.pathname = window.location.pathname;
    remoteUrl.search = window.location.search;
    remoteUrl.hash = window.location.hash;
    return remoteUrl.toString();
  } catch (error) {
    console.warn(`[${label}] Invalid remote app URL provided.`, error);
    return baseUrl;
  }
};
